import React, { Component } from "react";
import fileService from "../../services/fileService";
import { getInitials } from "../../utils/strings";
import { safePromise } from "../../utils/utils";

class Avatar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      profilePic: null
    };
    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;
    const { photo, image } = this.props;
    
    if (photo || image) {
      const thumbnailURL = photo?.thumbnailURL || image?.thumbnailURL;
      if (thumbnailURL) {
        safePromise(
          fileService.getFile(thumbnailURL),
          this,
          (profilePic) => ({ profilePic })
        );
      }
    }
  }
  
  componentDidUpdate(prevProps) {
    const prevThumbnail = prevProps.photo?.thumbnailURL || prevProps.image?.thumbnailURL;
    const currentThumbnail = this.props.photo?.thumbnailURL || this.props.image?.thumbnailURL;

    if (prevThumbnail !== currentThumbnail) {
      if (currentThumbnail) {
        safePromise(
          fileService.getFile(currentThumbnail),
          this,
          (profilePic) => ({ profilePic })
        );
      } else {
        this.setState({ profilePic: null });
      }
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const {
      photo,
      image,
      name,
      size = 70,
      square,
      rounded,
      maxSize,
      minSize,
      auto
    } = this.props;
    const { profilePic } = this.state;

    if (image) {
      if (!profilePic) return null;
      return (
        <img
          className="rounded-lg img-fluid m-auto"
          alt={name}
          src={profilePic}
          style={{ maxHeight: maxSize, minHeight: minSize, ...auto ? {
            width: "100%",
            height: "100%",
            objectFit: "contain",
          } : {} }}
        />
      );
    }

    if (photo) {
      return (
        <div
          className="img-avatar"
          id={"profilePic"}
          style={{
            overflow: "hidden",
            width: size,
            height: size,
            backgroundImage: "url('" + profilePic + "')",
            backgroundPosition: "center",
            backgroundSize: square || rounded ? "cover" : "contain",
            backgroundRepeat: "no-repeat",
            borderRadius: square ? "4px" : "50%",
          }}
        />
      );
    }

    return (
      <div
        className="avatar profileImgHolder"
        style={{
          width: size,
          height: size,
          background: "#63c2de",
          color: "#fff",
          borderRadius: square ? "4px" : "50%",
        }}
      >
        {name ? getInitials(name) : ""}
      </div>
    );
  }
}

export default Avatar;
